// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"e8c3f16d","169":"3b14707b","453":"dff87da4","480":"cc928409"}[chunkId] + ".chunk.js";
};